// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".label2[data-v-4255dc54] {\n  display: inline;\n  padding: 0.4em 5em 0.01em 6em;\n  font-size: 110%;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  line-height: 1.1;\n  position: absolute;\n  left: -1px;\n  top: 0;\n  border-radius: 0;\n}\n", ""]);
// Exports
module.exports = exports;
